import React from 'react';
import { P9301Filters } from '../hooks/useP9301Query';

interface FilterPanelProps {
  filters: P9301Filters;
  loading: boolean;
  onFilterChange: (field: keyof P9301Filters, value: string) => void;
  onEmpFromBlur: () => void;
  onDeptFromBlur: () => void;
  onQuery: () => void;
  onReset: () => void;
}

const FilterPanel: React.FC<FilterPanelProps> = React.memo(({
  filters,
  loading,
  onFilterChange,
  onEmpFromBlur,
  onDeptFromBlur,
  onQuery,
  onReset,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onQuery();
    }
  };

  return (
    <div className="filter-panel">
      <div className="filter-section">
        <div className="filter-tag">篩選條件</div>
        <div className="filter-grid">
          {/* Employee code range */}
          <label>人員代號</label>
          <div className="range-group">
            <span className="range-label">[從]</span>
            <input
              type="text"
              value={filters.empFrom}
              onChange={e => onFilterChange('empFrom', e.target.value)}
              onBlur={onEmpFromBlur}
              onKeyDown={handleKeyDown}
              placeholder="起始代號"
              maxLength={8}
              disabled={loading}
            />
            <span className="range-label">[至]</span>
            <input
              type="text"
              value={filters.empTo}
              onChange={e => onFilterChange('empTo', e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="結束代號"
              maxLength={16}
              disabled={loading}
            />
          </div>

          {/* Department code range */}
          <label>部門代號</label>
          <div className="range-group">
            <span className="range-label">[從]</span>
            <input
              type="text"
              value={filters.deptFrom}
              onChange={e => onFilterChange('deptFrom', e.target.value.toUpperCase())}
              onBlur={onDeptFromBlur}
              onKeyDown={handleKeyDown}
              placeholder="起始部門"
              maxLength={4}
              disabled={loading}
            />
            <span className="range-label">[至]</span>
            <input
              type="text"
              value={filters.deptTo}
              onChange={e => onFilterChange('deptTo', e.target.value.toUpperCase())}
              onKeyDown={handleKeyDown}
              placeholder="結束部門"
              maxLength={4}
              disabled={loading}
            />
          </div>
        </div>
      </div>

      <div className="filter-actions">
        <button
          className="btn btn-primary"
          onClick={onQuery}
          disabled={loading}
        >
          {loading ? '查詢中...' : '開始查詢'}
        </button>
        <button
          className="btn"
          onClick={onReset}
          disabled={loading}
        >
          清除條件
        </button>
      </div>
    </div>
  );
});

FilterPanel.displayName = 'FilterPanel';

export default FilterPanel;
